// app/table-labels.ts — тексты таблицы. Проект переопределяет их через TableProvider.
// Ключи `table.*` совпадают с прежними ключами локалей signals app, остальные — новые.

export const DEFAULT_TABLE_LABELS_EN = {
  "table.filters": "Filters",
  "table.filters.clearAll": "Clear all",
  "table.filters.noActive": "No active filters.",
  "table.filters.active": "Active Filters",
  "table.filters.add": "Add Filter",
  "table.filters.edit": "Edit Filter",
  "table.filters.apply": "Apply",
  "table.filters.selectColumn": "Select column...",
  "table.filters.addBtn": "Add",
  "table.filters.bar.aria": "Quick filter bar",
  "table.filters.quick.aria": "Quick filter menu",
  "table.filters.contains": "Contains...",
  "table.filters.min": "Min",
  "table.filters.max": "Max",
  "table.filters.from": "from",
  "table.filters.to": "to",
  "table.filters.select": "Select...",
  "table.filters.true": "True",
  "table.filters.false": "False",
  "table.filters.selectMulti": "Select multiple...",
  "table.filters.selectMultiDone": "Done",
  "table.filters.operator.equals": "Equals",
  "table.filters.operator.notEquals": "Not equals",
  "table.filters.operator.in": "One of",
  "table.filters.operator.notIn": "Not one of",
  "table.filters.operator.isEmpty": "Is empty",
  "table.filters.operator.isNotEmpty": "Is not empty",
  "table.filters.recent": "Recent",
  "table.clientRowLimit": "Showing first {count} rows. Use filters or pagination to narrow results.",
  "table.filters.aria.text": "Text filter input",
  "table.filters.aria.min": "Minimum value",
  "table.filters.aria.max": "Maximum value",
  "table.filters.aria.from": "From date",
  "table.filters.aria.to": "To date",
  "table.filters.aria.select": "Select value",
  "table.filters.aria.boolean": "Boolean value",
  "table.filters.aria.selectMulti": "Select multiple values",
  "table.filters.aria.columnSelect": "Select column to filter",
  "table.columns": "Columns",
  "table.columns.visible": "Visible Columns",
  "table.columns.showAll": "Show all",
  "table.columns.searchPlaceholder": "Search columns...",
  "table.columns.dragHint": "Drag column headers to reorder. Shift+click to multi-sort.",
  "table.preset": "Preset",
  "table.preset.default": "Default",
  "table.preset.builtin": "Built-in",
  "table.preset.myPresets": "My Presets",
  "table.preset.allColumns": "Default (all columns)",
  "table.preset.save": "Save current as preset",
  "table.preset.import": "Import presets",
  "table.preset.export": "Export presets",
  "table.preset.namePlaceholder": "Preset name...",
  "table.preset.outdated": "[missing]",
  "table.preset.outdatedConfirm": "Preset \"{name}\" references columns that no longer exist. Apply anyway?",
  "table.empty": "No results found.",
  "table.empty.filtered": "No results match the active filters.",
  "table.loading": "Loading...",
  "table.error": "Error",
  "table.page.showing": "Showing",
  "table.page.of": "of",
  "table.page.perPage": "/page",
  "table.page.previous": "Previous page",
  "table.page.next": "Next page",
  "table.clientFilters": "filter(s) applied client-side (applies to current page only)",
  "table.rowLimit.warning": "Showing first {count} of {total} rows. Use filters or pagination to narrow results.",
  "table.sort.by": "Sort by",
  "table.resize.column": "Resize column",
  "table.removeFilter": "Remove filter",
  "table.render.collapse": "Collapse",
  "table.render.expand": "Expand ({count})",
  "table.render.object": "Object ({count} keys)",
  "table.filters.minLabel": "min:",
  "table.filters.maxLabel": "max:",
  "table.filters.fromLabel": "from:",
  "table.filters.toLabel": "to:",
  "table.preset.delete": "Delete preset {name}",
  "table.preset.label": "Preset",
  "table.preset.aria.select": "Select preset",
  "table.preset.aria.nameInput": "Preset name",
  "table.filters.aria.toggle": "Toggle filters",
  "table.filters.selectedCount": "{count} selected",
  "table.columns.aria.toggle": "Toggle column visibility",
  "table.columns.aria.visibility": "Toggle visibility for {name}",
  "table.page.aria.size": "Page size",
  "table.bulkEdit.enter": "Bulk Mode",
  "table.bulkEdit.exit": "Exit Bulk Mode",
  "table.bulkEdit.save": "Save",
  "table.bulkEdit.cancel": "Cancel",
  "table.bulkEdit.saving": "Saving...",
  "table.bulkEdit.error": "Failed to save changes. Please try again.",
  "table.bulkEdit.selectedCount": "{count} selected",
  "table.bulkEdit.aria.enter": "Enter bulk edit mode",
  "table.bulkEdit.aria.exit": "Exit bulk edit mode",
  "table.bulkEdit.aria.save": "Save bulk edits",
  "table.bulkEdit.aria.cancel": "Cancel bulk edits",
  "table.bulkEdit.aria.rowSelect": "Select row",
  "table.bulkEdit.aria.editField": "Edit {column}",
  "table.bulkEdit.applyAll": "Apply to all selected",
  "table.bulkEdit.mixed": "mixed",
  "table.inlineEdit.doubleClick": "Double-click to edit",
  "table.editable": "Editable field",
  "table.edit.title": "Edit: {value}",
  "table.action.aria.button": "Action button",
  "exportData": "Export data",
  "export": "Export",
  "otherColumns": "Other",
  "reorderColumn": "Reorder column",
  "searchColumnsPlaceholder": "Search columns...",
  "searchColumnsAria": "Search columns",
  "closeDialog": "Close",
  "loading": "Loading…",
  "retry": "Retry",
  "chipIsEmpty": "is empty",
  "chipIsNotEmpty": "is not empty",
  "operatorContains": "contains",
  "operatorEquals": "equals",
  "operatorStarts": "starts with",
  "operatorEnds": "ends with",
  "operatorNotContains": "not contains",
  "operatorNotEquals": "not equals",
  "operatorAria": "Operator",
  "selectOperatorAria": "Select operator",
  "filterEmptyHint": "Filter empty values",
  "filterNonEmptyHint": "Filter non-empty values",
  "quickFilterEquals": "Filter by this value (= {value})",
  "quickFilterContains": "Filter containing \"{value}\"",
  "quickFilterGreater": "Filter > {value}",
  "quickFilterLess": "Filter < {value}",
  "clientTableEmpty": "No results.",
  "clientTableShowing": "Showing {from}-{to} of {total}",
} as const satisfies Record<string, string>;

export type TableLabelKey = keyof typeof DEFAULT_TABLE_LABELS_EN;
export type TableLabels = Record<TableLabelKey, string>;

/** Подстановка `{name}` в шаблон; непереданный параметр остаётся как есть. */
export function formatTableLabel(
  template: string,
  params?: Record<string, string | number>,
): string {
  if (!params) return template;
  let result = template;
  for (const [name, value] of Object.entries(params)) {
    result = result.replace(`{${name}}`, String(value));
  }
  return result;
}

/** Поверх значений по умолчанию накладываются только заданные проектом ключи. */
export function resolveTableLabels(overrides?: Partial<TableLabels>): TableLabels {
  return { ...DEFAULT_TABLE_LABELS_EN, ...overrides };
}

export type TableLabelFn = (
  key: TableLabelKey,
  params?: Record<string, string | number>,
) => string;

export function createTableLabelFn(labels: Partial<TableLabels> = {}): TableLabelFn {
  const resolved = resolveTableLabels(labels);
  return (key, params) => formatTableLabel(resolved[key], params);
}
